import React from "react";
import { TaskLaunchNumber } from "./task-launch-number.jsx";
import { routeHash } from "./helpers.mjs";
import { platformTaskQuery } from "./platform-tasks.mjs";
import { readySolutionSettingsHref } from "./ready-solution-admin.mjs";
import { READY_SOLUTION_STATUS_LEGEND, latestRunLabel, latestTaskMatchesPublication, readySolutionStatus } from "./ready-solution-status.mjs";

export function ReadySolutionStatus({ status }) {
  return <span className={`ready-solution-status ready-solution-status-${status.tone}`} title={status.detail}>
    <span className="ready-solution-status-dot" aria-hidden="true"/>{status.label}
  </span>;
}

export function ReadySolutionTable({ items, executions = {} }) {
  return <>
    <div className="ready-solution-status-legend" aria-label="Обозначения состояния">
      {READY_SOLUTION_STATUS_LEGEND.map(([tone, label]) => <ReadySolutionStatus key={tone} status={{ tone, label }}/>) }
    </div>
    <div className="table-wrap ready-solution-table-wrap"><table className="ready-solution-table">
      <caption>Состояние доступности и последнего запуска опубликованной версии. История запусков — по всем организациям.</caption>
      <thead><tr><th scope="col">№</th><th scope="col">Решение</th><th scope="col">Состояние</th><th scope="col">Версия</th><th scope="col">Последний запуск</th><th scope="col">Настройки</th></tr></thead>
      <tbody>{items.map((item, index) => {
        const execution = executions[item.solutionId] || {};
        const status = readySolutionStatus(item, execution);
        const task = execution.task;
        return <tr key={item.solutionId}>
          <td className="ready-solution-number">{index + 1}</td>
          <th scope="row"><a href={readySolutionSettingsHref(item.solutionId)}>{item.name}</a><small>{item.description}</small></th>
          <td><ReadySolutionStatus status={status}/><small>{status.detail}</small></td>
          <td>{item.version || "Не опубликовано"}</td>
          <td>{execution.loading ? "Загружаем…" : execution.error ? "История недоступна" : task ? <>
            <a href={routeHash("tasks", task.taskId, platformTaskQuery(task.scope))}>{execution.hasIssues ? "С замечаниями" : latestRunLabel(task)}</a>
            <TaskLaunchNumber task={task} compact/>
            <small>{new Date(task.createdAt).toLocaleString("ru-RU")}</small>
            {task.organizationName && <small>{task.organizationName}</small>}
            {!latestTaskMatchesPublication(item, task) && <small>Запуск другой опубликованной версии</small>}
          </> : latestRunLabel(null)}</td>
          <td><a className="button ghost small" aria-label={`Настройки решения «${item.name}»`} href={readySolutionSettingsHref(item.solutionId)}>Настройки</a></td>
        </tr>;
      })}</tbody>
    </table></div>
  </>;
}
